/* import __COLOCATED_TEMPLATE__ from './add-tag.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const AddTag = templateOnlyComponent<Signature>();
export default AddTag;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Tags::AddTag': typeof AddTag;
    'inbox2/conversation-details-sidebar/sidebar-sections/tags/add-tag': typeof AddTag;
  }
}
